<script>
import {
  CdrGrid,
} from '@rei/cedar';
import BreadCrumbComponent from '../../components/commons/BreadCrumbComponent.vue';
import StorePageHeading from '../../components/stores/StorePageHeading.vue';
import StoreDataComponent from '../../components/stores/StoreDataComponent.vue';
import StoreMediaComponent from '../../components/stores/StoreMediaComponent.vue';
import StoreSpecialMessageComponent from '../../components/stores/StoreSpecialMessageComponent.vue';
import StoreAtThisLocationComponent from '../../components/stores/StoreAtThisLocationComponent.vue';
import StoreAboutReiComponent from '../../components/stores/StoreAboutReiComponent.vue';
import CategoryRecsComponent from '../../components/stores/CategoryRecsComponent.vue';
import StoreNearbyComponent from '../../components/commons/nearby/StoreNearbyComponent.vue';
import DoMoreInStoreComponent from '../../components/stores/DoMoreInStoreComponent.vue';

import myStore from '../../mixins/stores/myStore';

export default {
  name: 'StorePage',
  components: {
    DoMoreInStoreComponent,
    StoreAtThisLocationComponent,
    StoreSpecialMessageComponent,
    StoreMediaComponent,
    StoreDataComponent,
    StorePageHeading,
    BreadCrumbComponent,
    StoreAboutReiComponent,
    StoreNearbyComponent,
    CategoryRecsComponent,
    CdrGrid,
  },
  mixins: [myStore],
  props: {
    clientConfig: {
      type: Object,
      default: () => {
      },
    },
    breadcrumbModel: {
      type: Object,
      default: () => {
      },
    },
    pageHeadingModel: {
      type: Object,
      default: () => {
      },
    },
    storeDataModel: {
      type: Object,
      default: () => {
      },
    },
    storeMediaModel: {
      type: Object,
      default: () => {
      },
    },
    storeAnnouncementModel: {
      type: Object,
      default: () => {
      },
    },
    storeAtThisLocationModel: {
      type: Object,
      default: () => {
      },
    },
    shopThisStoreModel: {
      type: Object,
      default: () => {
      },
    },
    storePagesDoMoreInStoreModel: {
      type: Object,
      default: () => {
      },
    },
    nearbyExperiencesModel: {
      type: Object,
      default: () => {
      },
    },
    nearbyModel: {
      type: Object,
      default: () => {
      },
    },
    storeAboutModel: {
      type: Object,
      default: () => {
      },
    },
    storePageTagsModel: {
      type: Object,
      default: () => {
      },
    },
  },
};
</script>
<template>
  <div class="department-page-vue-component">
    <div class="graySection">
      <bread-crumb-component
        v-if="breadcrumbModel.showBreadcrumb"
        :breadcrumb-data="breadcrumbModel"
      />
      <store-page-heading
        v-if="pageHeadingModel.showStoreHeading"
        :page-heading-data="pageHeadingModel"
        :store-data="storeDataModel"
        :is-enabled-my-store="isEnabledMyStore"
        :is-my-store="isMyStore"
        :is-my-store-toast-open="isMyStoreToastOpen"
      />

      <cdr-grid class="store-details__container">
        <div class="store-info__media">
          <div class="store-info__media-component">
            <store-media-component
              v-if="storeMediaModel.showStoreMedia"
              :store-media-data="storeMediaModel"
            />
          </div>
        </div>
        <div class="store-details__data">
          <store-data-component
            v-if="storeDataModel.showStoreData"
            :store-data="storeDataModel"
            :page-heading-data="pageHeadingModel"
            :is-my-store="isMyStore"
            :is-enabled-my-store="isEnabledMyStore"
            @my-store-selected="setAsMyREI"
          />
        </div>
        <div class="store-details__announcements-services">
          <store-special-message-component
            v-if="storeDataModel.showStoreData && !!storeDataModel.specialMessagesBelowStoreImage"
            :store-data="storeDataModel"
          />
          <store-at-this-location-component
            v-if="storeAtThisLocationModel.showStoreAtThisLocation"
            :page-at-this-location-data="storeAtThisLocationModel"
            :store-data="storeDataModel"
          />
        </div>
      </cdr-grid>
    </div>
    <category-recs-component
      v-if="shopThisStoreModel.enabled"
      :store-number="storeDataModel.storeNumber"
      :shop-this-store-model="shopThisStoreModel"
      data-ui="store-category-recommendations"
    />
    <do-more-in-store-component
      class="store-page-container"
      :store-pages-do-more-in-store-model="storePagesDoMoreInStoreModel"
    />
    <div class="store-page-container">
      <cdr-grid class="store-page-container__grid">
        <div>
          <store-about-rei-component
            v-if="storeAboutModel.enabled"
            :about-model="storeAboutModel"
          />
        </div>
        <div>
          <store-nearby-component
            v-if="nearbyModel.showStoreNearby"
            :store-nearby-data="nearbyModel"
          />
        </div>
      </cdr-grid>
    </div>
  </div>
</template>
<style lang="scss">
  @import "../../../style/pages/stores/entry.scss";
</style>
